import './index_mWeb.css';
import { Text, View } from '../../../component';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import React from 'react';

interface Props {
  counts?: any;
  teamACount?: number;
  teamBCount?: number;
  teamAName?: string;
  teamBName?: string;
  totalCreditCount: number;
  onPressPlayerMinus?: any;
  isSubstituteTeamPlayer?: boolean;
}
const CreateTeamHeaderFootballMWeb = ({
  counts,
  teamACount,
  teamBCount,
  teamAName,
  teamBName,
  totalCreditCount,
  onPressPlayerMinus,
  isSubstituteTeamPlayer = false
}: Props) => {
  const totalCount = counts['G/K'] + counts['DEF'] + counts['MID'] + counts['ST'];
  let gkCount = counts['G/K'];
  let defCount = counts['DEF'];
  let midCount = counts['MID'];
  let stCount = counts['ST'];
  const playerCountList = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  const maxTeamMsg = {
    color: '#fff'
  };

  const headerPlayerCount = {
    color: '#fff'
  };
  const headerPlayerValue = {
    color: '#fff'
  };
  const headerType = {
    color: '#000'
  };

  const className = `background-image: linear-gradient(red, yellow);`;

  const divider = {
    borderLeftColor: '#fff',
    borderRightColor: '#fff'
  };
  return (
    <View className={`create-team-header-container_mWeb ${className}`}>
      <View
        className={'create-team-header-item-wrapper_mWeb'}
        style={{
          backgroundColor: 'transparent'
        }}>
        <View className={'create-team-header-player-wrapper_mWeb'}>
          <View className={'create-team-header-player-content_mWeb'}>
            <Text className={'create-team-header-player-count_mWeb'} style={headerPlayerCount}>
              {`${totalCount}/`}
            </Text>
            <Text className={'create-team-header-player-value_mWeb'} style={headerPlayerValue}>
              {'11'}
            </Text>
          </View>
          <Text className={'create-team-header-player-title_mWeb'} style={headerPlayerValue}>
            {'Players'}
          </Text>
        </View>
        <View className={'create-team-header-player-type-wrapper_mWeb'} style={divider}>
          <View className={'create-team-header-tab-item-container_mWeb'}>
            <Text
              className={
                'create-team-header-team-name_mWeb'
              }>{`${teamAName} (${teamACount})`}</Text>
            <Text
              className={
                'create-team-header-team-name_mWeb'
              }>{`${teamBName} (${teamBCount})`}</Text>
          </View>
          {isSubstituteTeamPlayer ? (
            <Text className={'create-team-header-select-substitute_mWeb'} style={maxTeamMsg}>
              {'Select Your Substitutes'}
            </Text>
          ) : (
            <Text className={'create-team-header-max-msg_mWeb'} style={maxTeamMsg}>
              {I18n.t('MaxPlayers')}
            </Text>
          )}
        </View>
        <View className={'create-team-header-player-wrapper_mWeb'}>
          <Text
            className={'create-team-header-player-count_mWeb'}
            style={headerPlayerCount}>{`${totalCreditCount}`}</Text>
          <Text className={'create-team-header-player-title_mWeb'} style={headerPlayerValue}>
            {'Credits'}
          </Text>
        </View>
      </View>
      <View className={'create-team-header-player-type-list-wrapper_mWeb'}>
        {playerCountList.map((item, index) => {
          let title = '';
          if (gkCount > 0) {
            title = 'G/K';
            gkCount--;
          } else if (defCount > 0) {
            title = 'DEF';
            defCount--;
          } else if (midCount > 0) {
            title = 'MID';
            midCount--;
          } else if (stCount > 0) {
            title = 'ST';
            stCount--;
          }
          return (
            <View
              key={index}
              className={'create-team-header-player-list-item_mWeb'}
              style={{
                backgroundColor: title.length > 0 ? '#f2f2f2' : 'transparent',
                borderColor: '#d4d4d4'
              }}>
              <Text className={'create-team-header-player-list-item-text_mWeb'} style={headerType}>
                {title}
              </Text>
            </View>
          );
        })}
        <View onPress={onPressPlayerMinus}>
          <Constants.Svgs.PlayerTypeMinus width={18} height={18} />
        </View>
      </View>
    </View>
  );
};
export default React.memo(CreateTeamHeaderFootballMWeb);
